'use strict';

// Mobile apps controller
angular.module('mobile-apps').controller('GroupsController', [
  '$rootScope',
  '$scope',
  '$stateParams',
  '$location',
  'Authentication',
  'MobileApps',
  'Groups',
  '$state',
  'SweetAlert',
  'EntryCount',
  'AvailableLanguages',
  'EntryMain',
  'Languages',
  'Utilities',
  function (
    $rootScope,
    $scope,
    $stateParams,
    $location,
    Authentication,
    MobileApps,
    Groups,
    $state,
    SweetAlert,
    EntryCount,
    AvailableLanguages,
    EntryMain,
    Languages,
    Utilities
  ) {
    $scope.authentication = Authentication;
    $scope.mobileAppId = $stateParams.mobileAppId;
    $scope.groupId = $stateParams.groupId;

    $scope.groupCount = {};

    $scope.initDetailView = function() {
      $scope.mobileApp = MobileApps.get({
        mobileAppId: $stateParams.mobileAppId
      }, function(mobileApp)
      {
        Languages.query(
            {
              mobileAppId: $stateParams.mobileAppId
            },
            function success (languages) {
              $scope.masterLanguage= _.find(languages, { name : mobileApp.baseLanguage});
            });
      });


      $scope.availableLanguages = AvailableLanguages.get();

      if($scope.groupId) {
        $scope.group = Groups.get({
          mobileAppId: $stateParams.mobileAppId,
          groupId: $scope.groupId});
      }else
      {
        $scope.group = {};
      }

      $scope.fetchGroups(function(err, result)
      {
        if(err)
        {
          return;
        }
        $scope.groups = result;
        $scope.groupsArr = Object.values($scope.groups);
      });
    };

    $scope.initListView = function() {
      $scope.mobileApp = MobileApps.get({
        mobileAppId: $stateParams.mobileAppId
      }, function(mobileApp)
      {
        Languages.query(
            {
              mobileAppId: $stateParams.mobileAppId
            },
            function success (languages) {
              $scope.masterLanguage= _.find(languages, { name : mobileApp.baseLanguage});
            });
      });
      $scope.availableLanguages = AvailableLanguages.get();

      $scope.fetchGroups(function(err, result)
      {
        if(err)
        {
          return;
        }
        $scope.groups = result;

        $scope.groups.forEach(function(group)
        {
          $scope.groupCount[group._id] = $scope.group = EntryCount.getCountforGroups({
            mobileAppId: $stateParams.mobileAppId,
            groupId: group._id});
        });

        $scope.loadedStatus = true;
      });
    };

    $scope.trimString = function(text, maxLength)
    {
      if(typeof text === 'undefined') return '';
      if(typeof maxLength === 'undefined')
      {
        maxLength =36;
      }
      var result = text;
      var dots = '...';
      if(text.length > maxLength)
      {
        result = text.slice(0,maxLength - 1 - dots.length) + dots;
      }
      return result;
    };

    $scope.fetchGroups = function (callback) {
      Groups.list(
          {
            mobileAppId: $stateParams.mobileAppId
          },
          function success (response) {
            callback(null, response);
          }, function failure (errResponse) {
            callback(errResponse);
          });
    };

    $scope.fetchMobileApp = function (callback) {
      MobileApps.get({
        mobileAppId: $stateParams.mobileAppId
      }, function (response) {
        if(!angular.isFunction(callback)) return;
        return callback(null, response);
      }, function (errResponse) {
        if(!angular.isFunction(callback)) return;
        return callback(errResponse);
      });
    };

    // show add group screen
    $scope.add = function () {

        $state.go('createGroup', {
          mobileAppId: $scope.mobileApp._id
        });
    };

    // show edit group screen
    $scope.edit = function (groupId) {

      $state.go('editGroup', {
        mobileAppId: $scope.mobileApp._id,
        groupId : groupId
      });
    };

    $scope.save = function()
    {
      if($scope.groupId)
      {
        $scope.update();
      }else
      {
        $scope.create();
      }
    };

    // create new group
    $scope.create = function () {

      $scope.group.mobileApp = $scope.mobileApp._id;
      $scope.group = new Groups($scope.group);

      // Redirect after save
      $scope.group.$save(function (response) {
        // Force refresh of the cached app Data (with groups)
        EntryMain.loadMobileApp($scope.mobileApp._id, true, function() {});
        $state.go('listGroups', {
          mobileAppId: $scope.mobileApp._id
        });

      }, function (errorResponse) {
        $scope.error = errorResponse.data.message;
      });

    };


    // update group
    $scope.update = function () {

      $scope.group.$update(function (response) {
        $scope.group = response;

        // Force refresh of the cached app Data (with groups)
        EntryMain.loadMobileApp($scope.mobileApp._id, true, function() {});

        $state.go('listGroups', {
          mobileAppId: $scope.mobileApp._id
        });
      }, function (errorResponse) {
        $scope.error = errorResponse.data.message;
      });

    };

    // Remove existing Mobile app
    $scope.remove = function (cb) {
      $scope.group.$remove(function (response) {
        // Force refresh of the cached app Data (with groups)
        EntryMain.loadMobileApp($scope.mobileApp._id, true, function() {});
        cb(response);
      }, function (errorResponse) {
        $scope.error = errorResponse.data.message;
      });
    };


    $scope.removeCurrentGroup = function(groupId)
    {
      if($scope.authentication.user.lastGroupId && $scope.authentication.user.lastGroupId[$scope.mobileApp._id] === groupId)
      {
        delete $scope.authentication.user.lastGroupId[$scope.mobileApp._id];
      }
    };


    $scope.openDeleteGroupModal = function () {
        EntryCount.getCountforGroups({ mobileAppId: $scope.mobileApp._id, groupId: $scope.group._id}, function (group) {
            if(group.current) {
                return Utilities.showMessage(
                    'Warning!',
                    'Group has to be empty for deletion. You must move all keys out of this group in order to be able to delete it.',
                    'warning'
                );
            }

            SweetAlert.swal(
                {
                    title             : 'Are you sure?',
                    text              : 'This will delete the Group "' + $scope.group.name + '" and all included entries forever and can not be recovered.',
                    type              : 'warning',
                    showCancelButton  : true,
                    confirmButtonColor: '#DD6B55',
                    confirmButtonText : 'Yes, delete it!',
                    cancelButtonText  : 'No, cancel!',
                    closeOnConfirm    : true,
                    closeOnCancel     : true
                },
                function (isConfirm) {
                    if (isConfirm) {
                        $scope.remove(function () {
                            $scope.removeCurrentGroup($scope.group._id);
                            $state.go('listGroups', {
                                mobileAppId: $scope.mobileApp._id
                            });
                        });
                    }
                }
            );
        });
    };


  }
]);
